module.exports = __webpack_public_path__ + "img/italic-html.e84139b8.png";